import React from 'react';
import { Award, Users, MapPin } from 'lucide-react';
import { aboutData } from '../../data/mock';

const About = () => {
  return (
    <section id="about" className="py-20 lg:py-32 bg-white">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Images Side - Dos imágenes */}
          <div className="relative space-y-6">
            <div className="relative group">
              <div className="absolute -inset-4 bg-gradient-to-r from-[#63E61E]/20 to-transparent rounded-3xl blur-2xl group-hover:blur-3xl transition-all duration-500"></div>
              <div className="relative overflow-hidden rounded-3xl shadow-2xl">
                <img
                  src={aboutData.image}
                  alt="LUCARS Vehículo Eléctrico"
                  className="w-full h-[350px] object-cover transform group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-gray-900/50 to-transparent"></div>
                <div className="absolute bottom-4 left-4 bg-[#63E61E] px-4 py-2 rounded-full">
                  <span className="text-gray-900 font-bold text-sm">Vehículo Eléctrico</span>
                </div>
              </div>
            </div>
            
            <div className="relative group">
              <div className="absolute -inset-4 bg-gradient-to-r from-[#63E61E]/20 to-transparent rounded-3xl blur-2xl group-hover:blur-3xl transition-all duration-500"></div>
              <div className="relative overflow-hidden rounded-3xl shadow-2xl">
                <img
                  src={aboutData.image2}
                  alt="LUCARS Vehículo a Gasolina"
                  className="w-full h-[350px] object-cover transform group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-gray-900/50 to-transparent"></div>
                <div className="absolute bottom-4 left-4 bg-gray-900 px-4 py-2 rounded-full">
                  <span className="text-white font-bold text-sm">Vehículo a Gasolina</span>
                </div>
              </div>
            </div>
          </div>

          {/* Content Side */}
          <div className="space-y-8">
            <div>
              <div className="inline-block px-4 py-2 bg-[#63E61E]/10 rounded-full mb-4">
                <span className="text-[#63E61E] font-bold text-sm tracking-wide">SOBRE NOSOTROS</span>
              </div>
              <h2 className="text-4xl lg:text-5xl font-black text-gray-900 mb-6">
                {aboutData.title}
              </h2>
            </div>

            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p className="text-lg">{aboutData.description}</p>
              <p className="text-lg">{aboutData.description2}</p>
              <p className="text-lg">{aboutData.description3}</p>
            </div>

            {/* Value Proposition Highlight */}
            <div className="bg-gradient-to-r from-[#63E61E]/10 to-[#63E61E]/5 border-l-4 border-[#63E61E] p-6 rounded-r-2xl">
              <div className="flex items-start space-x-3">
                <Award className="w-6 h-6 text-[#63E61E] flex-shrink-0 mt-1" />
                <div>
                  <h3 className="font-bold text-gray-900 text-lg mb-2">Nuestro Valor Agregado</h3>
                  <p className="text-gray-700">{aboutData.valueProposition}</p>
                </div>
              </div>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 pt-6">
              {aboutData.stats.map((stat, index) => (
                <div key={index} className="text-center">
                  <div className="text-2xl lg:text-3xl font-black text-[#63E61E] mb-2">
                    {stat.number}
                  </div>
                  <div className="text-sm text-gray-600 font-medium">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;